import { render, staticRenderFns } from "./ListInfoCard.vue?vue&type=template&id=8be516a0&scoped=true"
import script from "./ListInfoCard.vue?vue&type=script&lang=js"
export * from "./ListInfoCard.vue?vue&type=script&lang=js"
import style0 from "./ListInfoCard.vue?vue&type=style&index=0&id=8be516a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be516a0",
  null
  
)

export default component.exports